import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { PageEvent, MatSnackBar } from '@angular/material';
import { SessionService } from '../../service/session/session.module';
import * as Rx from 'rxjs/Rx';
import { LoadingService } from '../../directive/loading/loading.module';

@Component({
  selector: 'app-admin-patient',
  templateUrl: './admin-patient.component.html',
  styleUrls: ['./admin-patient.component.css']
})
export class AdminPatientComponent implements OnInit {

  @ViewChild('drawer',{static:true})drawerCtrl: MatDrawer;
  patientMin = {
    system:{
      company:{
        main:{
          uuid:''
        }
      },
    },
    max: 10,
    offset: 0,
    sort:"sPhysicalPerson.mName",
    order:"asc",
    filter:{
      name:'',
      value: ''
    }
  }

  paginatorModel = {
    total:0,
    pageSizeOptions:[ 2 ,5, 10, 25, 100, 200, 500, 1000],
  };

  pageEvent: PageEvent;

  metadata = {
    searchBoxInput: new Rx.Subject<string>(),
    object:{
      main:{
        uuid:''
      }
    }
  }

  list = [];

  constructor(private session: SessionService, public snackBar: MatSnackBar, public loadingService: LoadingService) { }

  ngOnInit() {
    this.patientMin.system.company.main.uuid = this.session.getSessionObject().main.uuid;
    this.metadata.searchBoxInput.debounceTime(700)
    .switchMap(val => {
      // console.log('called once',val)
      if(val != ''){
        this.list = [];
        this.patientMin.filter.name = 'searchElement';
      }else{
        this.list = [];
        this.patientMin.filter.name = '';
        this.patientMin.filter.value = '';
        val = 'false'
      }
      this.findAllByCompany();
      return val;
    }).subscribe(results => {
      // Modificaciones sobre cada letra si se requiere
    }, error => {
        console.log('error logged: ', error);
        this.snackBar.open(error.message, 'Error', { duration: 5000 });
      });
    this.findAllByCompany();
  }

  findAllByCompany() {
    this.loadingService.wait();
    this.patientMin.system.company.main.uuid = this.session.getSessionObject().main.uuid;
    this.session.getRequest("patient:findAllByCompany", this.patientMin).subscribe((data:any)=>{
      this.list = data.object.instanceList;
      this.paginatorModel.total = data.object.total;
      this.loadingService.hide();
    },error=>{
      console.log("error",error);
      this.loadingService.hide();
    })
  }

  toogleMenu(ev){
    this.drawerCtrl.opened = ev;
  }

  /**
   * Funcion para buscar
   */
  search() {
    this.metadata.searchBoxInput.next(this.patientMin.filter.value);
  }

  /**
   * funcion para obtener los datos del paginado.
   */
  onPaginateChange(event) {
    this.patientMin.offset = (event.pageIndex * event.pageSize);
    this.patientMin.max = event.pageSize;
    this.findAllByCompany();
  }

}
